<template>
    <Page
        :class="['DshPage',`DshPage-${mode}`, obj.class]"
        :total="total"
        :current="obj.page"
        :page-size="obj.pagesize"
        :page-size-opts="obj.pagesizeOpts"
        :placement="obj.placement"
        :size="size"
        :simple="simple"
        :show-total="obj.showTotal"
        :show-elevator="obj.showElevator"
        :show-sizer="obj.showSizer"
        :transfer="obj.transfer"
        :prev-text="obj.prevText"
        :next-text="obj.nextText"
        :disabled="obj.disabled"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
    />
</template>
<script>
    export default {
        name: "DshPage",
        props: {
            mode: {
                type: String,
                default: "default",
                validator: function (value) {
                    return ["simple", "default", "small"].indexOf(value) !== -1;
                }
            },
            total: {
                type: Number,
                default: 0
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            obj () {
                let obj = {};
                if (this.mode === "default") {
                    obj = {
                        showTotal: true,
                        showElevator: false,
                        showSizer: true
                    };
                } else if (this.mode === "small") {
                    obj = {
                        showTotal: true,
                        showElevator: false,
                        showSizer: false
                    };
                } else if (this.mode === "simple") {
                    obj = {
                        // // 简洁分页不能使用总数、电梯和切换数量
                        // showTotal: true,
                        // showElevator: false,
                        // showSizer: false
                    };
                }
                return {
                    page: 1,
                    pagesize: 10,
                    pagesizeOpts: [10, 12, 15, 20, 30, 40, 50],
                    transfer: false,
                    placement: "bottom",
                    ...obj,
                    ...this.propsObj
                };
            },
            size () {
                return this.mode == "small" ? "small" : undefined;
            },
            simple () {
                return this.mode == "simple" || false;
            }
        },
        created () {},
        methods: {
            // 换页
            changePage (page) {
                this.$emit("changePage", page);
            },
            // 换每页显示的条数
            changePageSize (pagesize) {
                this.$emit("changePageSize", pagesize);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshPage.vue